<template>
	<div style="width: 1000px;margin: 70px auto;">
		<bar></bar>
		<div style="width: 1000px;height: 30px; margin-top: 20px;;border-bottom: 1px solid #000000;"><span style="font-size: 14px;float: left">首页/订单确认</span></div>
		<div class="middle-table">
			<el-table :data="list" border style="width: 100%;">
				<el-table-column type="index" align="center" label='No.' min-width="50">
            	</el-table-column>
				<el-table-column align="center" label='SKU code' min-width="120">
					<template slot-scope="scope">
					{{scope.row.skuCode}}
					</template>
				</el-table-column>
				<el-table-column align="center" label='商品名称' min-width="150">
					<template slot-scope="scope">
					{{scope.row.productName}}
					</template>
				</el-table-column>
				<el-table-column align="center" label='图片' min-width="100">
					<template slot-scope="scope">
					<img style="width:40px;height:40px;" :src="$store.getters.imageUrl + '/' + scope.row.productImgPath" alt="" />
					</template>
				</el-table-column>
				<el-table-column align="center" label='福豆' min-width="100">
					<template slot-scope="scope">
					{{scope.row.unitPrice}}
					</template>
				</el-table-column>
				<el-table-column align="center" label='数量' min-width="150">
					<template slot-scope="scope">
					{{scope.row.buyCount}}
					</template>
				</el-table-column>
				<el-table-column align="center" label='总福豆' min-width="120">
					<template slot-scope="scope">
					{{scope.row.buyCount*scope.row.unitPrice}}
					</template>
				</el-table-column>
			</el-table>
		</div>
				<div style="text-align: left;margin: 0 auto;width: 520px;height: 100px;">
					<div style="margin:10px 0 30px 30px;">
						<span style="font-size: 14px;">
							送货地址
							<span style="font-size: 13px;padding-left: 15px;">{{deliveryAddress}}</span>
						</span>
					</div>
					<div  style="margin:10px 0 0 30px;">
						<span style="font-size: 14px;">
							订单总福豆
							<span style="font-size: 13px;padding-left: 15px;">{{orderAmount}}</span>
						</span>
					</div>
				</div>				
				<div style="float: left;width: 550px;margin-left: 243px;height:160px;">
					<span style="padding-right: 20px;font-size: 14px;">支付方式</span>
			<el-radio-group v-model="radio">
				<el-radio :label="0">货到付款</el-radio>
				<el-radio disabled :label="1">工资支付</el-radio>
				<el-radio :label="2">至财务处付款</el-radio>
			</el-radio-group>
			</div>
			<!-- <div style="float: left;width: 450px;margin-left: 243px;">
					
			
				<span style="padding-right: 20px;font-size: 16px; color:red;">本人已知悉该自用品福利将依法并入薪资计税。</span>
			</div> -->
			
			<div style="height:160px;margin-top: 180px;">
				    <el-button :disabled="isSubmit" @click="addCarInfo" type="primary">提交</el-button>
					<el-button @click="goBack" type="primary">返回</el-button>
			</div>
		</div>
</template>

<script>
import bar from '@/components/bar.vue';
import { orderCheck, orderAdd } from '../api/service'

export default {
	data() {
		return {
			params: {},
			list: null,
			deliveryAddress: '',
			orderAmount: '',
			radio: 0,
			isSubmit: false
			// checked: false
		};
	},
	created() {
		this.params = this.$route.query
		// this.checked = false
		this.fetchData()
	},
	methods: {
		goBack () {
			this.$router.go(-1)
		},
		fetchData () {
			orderCheck(this.params).then((response) => {
				if (response.data.success === true) {
					this.list = response.data.data.cartList
					this.deliveryAddress = response.data.data.deliveryAddress
					this.orderAmount = response.data.data.orderAmount
				} else {
					this.$alert(response.data.message, '提示', {
						confirmButtonText: '确定',
					});
				}
			}).catch(() => {
					this.$alert('查询失败', '提示', {
						confirmButtonText: '确定',
					});
			})
		},
		addCarInfo (item) {
			// if(!this.checked){
			// 	this.$alert('请先勾选已知晓，才能提交订单！', '提示', {
			// 		confirmButtonText: '确定',
			// 	});
			// 	return
			// }
			this.$confirm('确定要提交订单吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.isSubmit = true
				const params = {
					activityId: this.params.activityId,
					staffId: this.$store.getters.id,
					paymentMethod: this.radio,
					cartList: this.params.cartList
				}
				orderAdd(params).then((response) => {
					if (response.data.success === true) {
						this.$alert('购买成功', '提示', {
							confirmButtonText: '确定',
						});
						const para = {
							id: response.data.data
						}
						this.$router.push({ path: 'orderDetail', query: para })
					} else {
						this.$alert(response.data.message, '提示', {
							confirmButtonText: '确定',
						});
					}
					this.isSubmit = false
				}).catch(() => {
						this.$alert('购买失败', '提示', {
							confirmButtonText: '确定',
						});
						this.isSubmit = false
				})
			}).catch(() => {
				this.$message({
				type: 'info',
				message: '已取消'
				})
			})
		}
	},
	components: {
		bar
	}
};
</script>

<style scoped="">
.clearfix:after{
	content: '';
	display: block;
	clear: both;
}
.top-bar {
	position: fixed;
	top: 0;
	bottom: auto;
	left: 0;
	right: auto;
	width: 100%;
}
.top-color {
	height: 40px;
	background: #be0f34;
}
.top-color img {
	width: 209px;
	margin-top: 8px;
}
.middle-table {
	width: 892px;
	margin: 25px auto;
}
.confirm-border {
	background-color: orange;
	width: 111px;
	height: 34px;
	z-index: 100;
	margin-left: 296px;
}
.confirm-border span {
	line-height: 35px;
	text-align: center;
	color: white;
}
.order-box {
	margin: 42px auto;
	width: 600px;
}
.order-box span {
	font-size: 14px;
	color: #606266;
}
.confirm-button {
	float: right;
	margin-top: 120px;
}
</style>
